// signature-document.component.ts
import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Importaciones de PrimeNG
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ListboxModule } from 'primeng/listbox';
import { DividerModule } from 'primeng/divider';
import { CardModule } from 'primeng/card';
import { PanelModule } from 'primeng/panel';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TooltipModule } from 'primeng/tooltip';
import { SplitterModule } from 'primeng/splitter';
import { ImageModule } from 'primeng/image';
import { SelectModule } from 'primeng/select';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SignGenericService } from './services/sign-generic.service';
import { IPosXY, ISignFile } from './interface/sign.interface';

@Component({
  selector: 'app-modal-sign-generic',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    DialogModule,
    ListboxModule,
    DividerModule,
    CardModule,
    PanelModule,
    ScrollPanelModule,
    TooltipModule,
    SplitterModule,
    ImageModule,
    SelectModule,
    ConfirmDialogModule,
  ],
  providers: [SignGenericService, ConfirmationService],
  templateUrl: './modal-sign-generic.component.html',
  styleUrl: './modal-sign-generic.component.scss',
})
export class ModalSignGenericComponent {
  // servicios
  signService = inject(SignGenericService);

  // parametros
  base64ImageSign = signal<string | null>(null);
  posXY = signal<number | null>(null);

  // Control interfaz
  onDisabledButtonsSign() {
    return !(
      this.base64ImageSign() &&
      this.posXY() &&
      !this.signService.isDocumentSign()
    );
  }

  // Funciones
  async onFirmaChange(event: any) {
    if (event?.value?.UrlFirma) {
      const file = await this.signService.getSignFile(event.value.UrlFirma);
      this.signService.selImagenFirma.set(event?.value as ISignFile);
      this.base64ImageSign.set(`data:${file.ContentType};base64,${file.fileBase64}`);
    }
  }

  onPosicionChange(event: any) {
    if (event?.value?.idPosxy) {
      this.signService.selPosXy.set(event?.value as IPosXY);
      this.posXY.set(event?.value?.idPosxy);
    }
  }

  async onPreview() {
    await this.signService.onPreview();
  }

  async onSign() {
    await this.signService.onSign();
  }
}
